import React, {useState , useEffect} from 'react';
import {  Row, Col, Input, Card, CardHeader, CardBody, Button, ListGroup, ListGroupItem } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// Import Images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../assets/images/users/avatar-4.jpg";
import CreateNewBot from '../../Components/Common/CustomModal/CreateNewBot';


const Bot_In_Group = ({ group_id}) => {


    const navigate = useNavigate()

   


    const group_owner = useSelector((state)=>state.GroupOwner)



    
    const onChange_Search_By_Bot_title = (e)=>{
        const search_value = e.target.value.toLowerCase();


        const temp = group_owner.Group_Bots.filter((ele,i)=>{
            return ele.Bot_Title.toLowerCase().includes(search_value)
       })

    
       setbotList(temp)
    }


    const [botList, setbotList] = useState([])

    useEffect(() => {
         
        setbotList(group_owner.Group_Bots)

    }, [group_owner.Group_Bots])

  return (
    <React.Fragment>
        <Card>
            <CardHeader className='no_border_bot'>
                <div className="d-flex align-items-center">
                    <div className="flex-shrink-0">
                        <h6 className="card-title mb-0">Bots in this group</h6>
                    </div>
                    <div className="flex-grow-1 ms-2 padding-sm" style={{textAlign : 'right'}}>
                    {group_owner?.Group_Details?.User_Role !== 'General User' && <CreateNewBot group_id={group_id} className="mb-3"/>}
                       {/* <button type="button" className="rounded-pill btn btn-primary float-end fs-11">CREATE NEW BOT</button>  */}
                    </div>
                </div>                            
                
            </CardHeader>
            <CardBody className='no_padding'>
                <div className='sort_search'>
                    <Row>
                        <Col>
                            <div className='search'>
                                <div className="input-group">
                                    <Input onChange={onChange_Search_By_Bot_title} type="text" className="form-control h-40" aria-label="Search name" placeholder="Search name"/>
                                    <button className="btn btn-secondary padd_10" type="button"><i className="bx bx-search fs-20"></i></button>
                                </div>
                            </div>
                        </Col>
                        {/* <Col>
                            <div className='sort'>
                            <select className="form-select rounded-pill mb-3" aria-label="Default select example">
                            <option value={''} > Sort by role                             
                            </option>
                                <option value={'Super User'} > Super User                             
                                </option>
                                <option value={'General User'} >General User                           
                                </option>
                                <option value={'Admin'} >Admin                           
                                </option>
                            </select>
                            </div>
                        </Col> */}
                    </Row>
                </div>
                <ListGroup className='border-none list-height'>

                    {
                    botList.map((ele,i)=>{
                            const { Bot_Title, NumberOfUsers, Bot_ID , Bot_Logo ,Assets_ID } = ele 
                              return  <ListGroupItem key={i}>
                              <div 
                              onClick={()=>{
                                navigate('/Configuration',
                                   {state: {
                                    Bot_ID,
                                    Assets_ID
                                    }}
                                )
                              }}
                              className="d-flex align-items-center">
                                  <div className="flex-shrink-0">
                                      <img src={ Bot_Logo || avatar1} alt="" className="avatar-xs rounded-circle" />
                                  </div>
                                  <div className="flex-grow-1 ms-2 mb_0">
                                      <p className='mb_0'><b>{Bot_Title}</b></p>
                                      <p className='mb_0'><small class="text-muted">{NumberOfUsers} users</small></p>
                                  </div>
                              </div>
                          </ListGroupItem>
                         })
                    }
                   
                    
                </ListGroup>
            </CardBody>
            {/* <div className="card-footer">
                <Link to="#" className="link-success float-end">Read More <i className="ri-arrow-right-s-line align-middle ms-1 lh-1"></i></Link>
                <p className="text-muted mb-0">1 days Ago</p>
            </div> */}
        </Card>
    </React.Fragment>
  )
}

export default Bot_In_Group
